var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3695_5438)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 16.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#FAFAFA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7038 30.7539H38.5428C38.2394 29.7499 37.3078 29.0195 36.2058 29.0195C35.1039 29.0195 34.1723 29.7508 33.8689 30.7539H32.4158C32.0254 30.7539 31.7092 31.0701 31.7092 31.4604C31.7092 31.8508 32.0254 32.167 32.4158 32.167H33.8689C34.1723 33.171 35.1039 33.9013 36.2058 33.9013C37.3078 33.9013 38.2394 33.1701 38.5428 32.167H47.7038C48.0942 32.167 48.4103 31.8508 48.4103 31.4604C48.4112 31.0701 48.0942 30.7539 47.7038 30.7539ZM36.2475 32.7763C35.5214 32.7763 34.9316 32.1874 34.9316 31.4604C34.9316 30.7343 35.5205 30.1445 36.2475 30.1445C36.9737 30.1445 37.5634 30.7335 37.5634 31.4604C37.5626 32.1874 36.9737 32.7763 36.2475 32.7763Z",
    fill: "#838383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7038 39.9023H38.5428C38.2394 38.8984 37.3078 38.168 36.2058 38.168C35.1039 38.168 34.1723 38.8992 33.8689 39.9023H32.4158C32.0254 39.9023 31.7092 40.2185 31.7092 40.6089C31.7092 40.9992 32.0254 41.3154 32.4158 41.3154H33.8689C34.1723 42.3194 35.1039 43.0498 36.2058 43.0498C37.3078 43.0498 38.2394 42.3185 38.5428 41.3154H47.7038C48.0942 41.3154 48.4103 40.9992 48.4103 40.6089C48.4112 40.2185 48.0942 39.9023 47.7038 39.9023ZM36.2475 41.9248C35.5214 41.9248 34.9316 41.3359 34.9316 40.6089C34.9316 39.8827 35.5205 39.293 36.2475 39.293C36.9737 39.293 37.5634 39.8819 37.5634 40.6089C37.5626 41.3359 36.9737 41.9248 36.2475 41.9248Z",
    fill: "#838383"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7038 35.1992H46.4646C46.1612 34.1952 45.2296 33.4648 44.1276 33.4648C43.0257 33.4648 42.0941 34.1961 41.7907 35.1992H32.4156C32.0253 35.1992 31.7091 35.5154 31.7091 35.9058C31.7091 36.2961 32.0253 36.6123 32.4156 36.6123H41.7907C42.0941 37.6163 43.0257 38.3467 44.1276 38.3467C45.2296 38.3467 46.1612 37.6154 46.4646 36.6123H47.7038C48.0941 36.6123 48.4103 36.2961 48.4103 35.9058C48.4112 35.5154 48.0941 35.1992 47.7038 35.1992ZM44.1431 37.2217C43.4169 37.2217 42.8272 36.6327 42.8272 35.9058C42.8272 35.1796 43.4161 34.5899 44.1431 34.5899C44.8692 34.5899 45.459 35.1788 45.459 35.9058C45.459 36.6327 44.8701 37.2217 44.1431 37.2217Z",
    fill: "#838383"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3695_5438",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3695_5438"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3695_5438",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.2e97ee0ebf3e81e1705a872983b65bbf.svg";
export { ForwardRef as ReactComponent };